<template>
<main class="bg-main lesson-explanation">
  <contenthead :section="sectionData" :lesson="lessonData" :contentsData="contentsData"></contenthead>
  <section class="container">
    <div class="heading-content-title">{{ $t('lesson.exam.title') }}</div>

    <div class="row">
      <ol class="rounded-list">
        <li>1. {{ $t('lesson.' + step + '.rule_1') }}</li>
        <li>2. {{ $t('lesson.' + step + '.rule_3') }}</li>
      </ol>
    </div>

    <div class="row">
      <a @click.prevent="startExam" class="button button-primary next">{{ $t('lesson.question.button.start') }}</a>
      <a class="button button-primary button-back" @click="back">{{ $t('common.button.back') }}</a>
    </div>

  </section>
</main>
</template>

<script>

import {api, appEnv, useCoachmark} from './../../config';

import {mapState, mapGetters} from 'vuex'

import componentContentHead from '../shared/ContentHead.vue';

import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

  export default {
    name: 'LessonExplanation',
    components: {
      'contenthead': componentContentHead,
    },
    props: {
      step: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        lessonId: null,
        authUser: null,
        driver: null,
        contents_data: {},
        driver: null,
        storage: {}
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      ...mapGetters([
        'selectedLanguage'
      ]),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      contentsData() {
        return this.contents_data;
      },
    },

    created() {
      
      this.authUser = this.$store.getters.getAuthUser;
      
      this.lessonId = this.$route.params['lesson_id']
      
      
      axios.get(api.contents, {
        params: {
          section_id: this.$store.getters.section_data.section_id,
          lesson_id: this.$store.getters.lesson_data.lesson_id,
          lesson_type: this.$store.getters.lesson_data.lesson_type
        }
      })
      .then((resp) => {
        this.contents_data = resp.data
      })

      this.initCoachMark();

    },

    mounted() {
      
      if(appEnv !== 'local') {
        const TypeSquareJS = window.TypeSquareJS;
        TypeSquareJS.loadFont && TypeSquareJS.loadFont();
      }
    },
    methods: {
      startExam: function () {
        this.$router.push({name: 'lesson.exam', params: { lesson_id: this.lessonId }});
      },
      back() {
        this.$router.push({ name: 'lesson.review', params: { lesson_id: this.lessonId, content_order: 1 }})
      },
      initCoachMark() {
        if(this.driver) {
          this.driver.reset()
        } else {
          const driverOverlay = document.getElementById('driver-page-overlay')
          const driverStage = document.getElementById('driver-highlighted-element-stage')
          const driverItem = document.getElementById('driver-popover-item')
          const driverItem2 = document.getElementById('driver-popover-item2')
          
          if(driverOverlay) {
            driverOverlay.remove()
          }
          if(driverStage) {
            driverStage.remove()
          }
          if(driverItem) {
            driverItem.remove()
          }
        }
      }
    },
  }
</script>
<style scoped>

</style>
